import React, { useEffect, useState } from "react";
import {
  data,
  Link,
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";
import {
  Box,
  Typography,
  Button,
  Chip,
  IconButton,
  Divider,
  Grid,
  Input,
  FormHelperText,
  TextField,
  Avatar,
  CircularProgress,
  Tooltip,
  Backdrop,
} from "@mui/material";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionIcon from "@mui/icons-material/Description";
import GridOnIcon from "@mui/icons-material/GridOn";
import TableChartIcon from "@mui/icons-material/TableChart";
import InsertDriveFileIcon from "@mui/icons-material/InsertDriveFile";
import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import FileUploadIcon from "@mui/icons-material/FileUpload";

import { ArrowBack, UploadFile } from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import { enqueueSnackbar } from "notistack";
import { useIds } from "../../hook/AdminContext";
import {
  apply_job_api,
  favourite_live_job_api,
  get_hr_blog_etail_api,
  get_live_job_feed_etail_api,
  upload_image_documents_on_s3,
} from "../../DAL/TalentSourceAPI/TalentSourceApi";
import PageLoading from "../../components/loader/PageLoading";
import {
  addCommasToNumber,
  formatEducationRequired,
  getFileIcon,
  show_des_data,
  show_proper_words,
} from "../../utils/Constant";
import { s3baseUri } from "../../config/config";
import {
  live_job_feed_detail,
  upload_file_on_s3,
  yourecruite_api,
} from "../../DAL/jobs/jobs";
import JobDescriptionBlock from "../../components/jobs/components/JobDescriptionBlock";
import QuickApplyModal from "../../components/QuickApply/QuickApplyModal";
import { ExternalLink } from "lucide-react";
import { calender_icon, three_dots_icon } from "../../assets";
import AboutDescription from "../Clients/components/profile-sections/AboutDescription";

export default function PostJobDetails({
  targetJob = null,
  isClientDetailsFlow = false,
  handleBack = () => {},
}) {
  const location = useLocation();
  const navigate = useNavigate();

  const job = location.state?.job || targetJob || {};

  const [openQuickApply, setOpenQuickApply] = useState(false);

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [loading, setLoading] = useState(true);
  const [files, setFiles] = useState([]);

  const [cvName, setCvName] = useState(""); // State to store CV file name
  const [cv, setcv] = useState(); // State to store CV file name
  const [shortDescription, setShortDescription] = useState("");
  const { setBreadCrumb, userInfo, setUpdateJobOnNotification } = useIds();
  const [dataapi, setDataApi] = useState();
  const params = useParams();

  const [bookmarkedJobs, setBookmarkedJobs] = useState({});
  const [result_application, set_result_application] = useState({});
  const [uploading, setUploading] = useState(false);
  const [cvDownloadLoading, setCvDownloadLoading] = useState(false);
  const [additionalDocDownloadLoading, setAdditionalDocDownloadLoading] =
    useState({});

  const handleCvNull = () => {
    setcv(null);
    setCvName(null);
    // Reset the file input element to allow selecting the same file again
    const fileInput = document.getElementById("image-upload");
    if (fileInput) {
      fileInput.value = "";
    }
  };

  const Job_by_state = location?.state?.job;
  const firstSegment = location.pathname.split("/")[1];
  const fetchCategories = async () => {
    setLoading(true);
    const response = await live_job_feed_detail(
      params.job_slug || targetJob.job_slug
    );
    if (response.code === 200) {
      setDataApi(response.job);
      set_result_application(response?.job?.job_application);
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
      navigate(-1);
    }
    setLoading(false);
  };

  useEffect(() => {
    if (dataapi?.applied_status && result_application) {
      setShortDescription(result_application.job_description);
      setCvName(result_application.cv);

      if (result_application?.additional_documents) {
        setFiles(
          result_application?.additional_documents.map((doc) => ({
            name: doc,
            url: s3baseUri + doc,
          }))
        );
      }
    }
  }, [result_application]);
  useEffect(() => {
    fetchCategories();
  }, [params?.job_slug, targetJob?.job_slug]);
  const handleBookmarkToggle = (jobId) => {
    let id = { job_id: jobId };

    favourite_live_job_api(id)
      .then((response) => {
        setDataApi((prev) => ({
          ...prev,
          is_favourite: !prev.is_favourite,
        }));
        enqueueSnackbar(response.message, { variant: "success" });
      })
      .catch((error) => {
        enqueueSnackbar("Failed to update favorite status!", {
          variant: "error",
        });
      });
  };
  const removeFile = (indexToRemove) => {
    setFiles((prevFiles) =>
      prevFiles.filter((_, index) => index !== indexToRemove)
    );
  };

  useEffect(() => {
    const storedBookmarks =
      JSON.parse(localStorage.getItem("bookmarkedJobs")) || {};
    setBookmarkedJobs(storedBookmarks);
  }, []);
  const handleFileChangeAdditional = (e) => {
    const selectedFiles = Array.from(e.target.files);

    const allowedTypes = [
      "application/pdf",
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
      "application/vnd.ms-excel",
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      "text/csv",
      "image/jpeg", // for .jpg and .jpeg
      "image/png", // for .png
    ];

    const validFiles = selectedFiles.filter((file) =>
      allowedTypes.includes(file.type)
    );

    if (validFiles.length !== selectedFiles.length) {
      enqueueSnackbar(
        "Only PDF, DOC, DOCX, XLS, XLSX, CSV, JPG, and PNG files are allowed",
        { variant: "error" }
      );
    }

    const maxFiles = 5;
    if (files.length + validFiles.length > maxFiles) {
      enqueueSnackbar("You can only upload up to 5 documents.", {
        variant: "error",
      });
      return;
    }

    setFiles((prev) => [...prev, ...validFiles]);
    e.target.value = null;
  };

  // Handle file selection
  const handleFileChange = (event) => {
    const file = event.target.files[0];
    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
    if (file.size > MAX_FILE_SIZE) {
      enqueueSnackbar("Maximum allowed file size is 5MB.", {
        variant: "error",
      });
      return;
    }
    setcv(file);
    if (file) {
      setCvName(file.name);
    }
  };
  const salaryFrequency = (type) => {
    switch (type) {
      case "Monthly":
        return "month";
      case "Yearly":
        return "year";
      case "Anually":
        return "annually";
      case "Weekly":
        return "week";
      case "Daily":
        return "day";
      case "Hourly":
        return "hour";
      default:
        return "";
    }
  };
  const isFromMyJobPost =
    location.pathname.includes("/my-job-post/") ||
    location.state?.pathname?.includes("my-job-post");
  const isFromFavouriteJobPost = location.pathname.includes(
    "favourite-jobs/detail/"
  );

  const breadcrumbPath = isFromMyJobPost
    ? `/${firstSegment}/live-job-feed/my-job-post`
    : isFromFavouriteJobPost
    ? `favourite-jobs`
    : `/${firstSegment}/live-job-feed`;

  const HandleApplyJob = async () => {
    // if (!cvName) {
    //   enqueueSnackbar("Please attach your CV before applying!", {
    //     variant: "error",
    //   });
    //   return;
    // }
    if (!cv) {
      enqueueSnackbar("Please attach your CV before applying!", {
        variant: "error",
      });
      return;
    }
    const newcv = cvName.toLowerCase();
    const allowedExtensions = [".pdf", ".doc", ".docx"];

    // Check if the file has a valid extension
    if (!allowedExtensions.some((ext) => newcv.endsWith(ext))) {
      enqueueSnackbar("Only PDF, DOC, and DOCX files are accepted!", {
        variant: "error",
      });
      return;
    }

    const MAX_FILE_SIZE = 5 * 1024 * 1024; // 5MB
    if (cv.size > MAX_FILE_SIZE) {
      enqueueSnackbar("Maximum allowed CV file size is 5MB.", {
        variant: "error",
      });
      return;
    }

    setIsSubmitting(true);
    let uploadedFiles = [];
    for (let file of files) {
      const formData = new FormData();
      formData.append("file", file);
      try {
        const res = await upload_file_on_s3(formData);
        if (res.code === 200) {
          uploadedFiles.push(res.image_path);
        }
      } catch (err) {
        enqueueSnackbar(`Failed to upload ${file.name}`, { variant: "error" });
      }
    }

    let data = {
      Job_id: params.jobId,
      cv: cvName,
      job_description: shortDescription,
    };
    const formData = new FormData();
    formData.append("job_slug", params?.job_slug || targetJob.job_slug);
    formData.append("cv", cv);
    formData.append("job_description", shortDescription);
    formData.append("additional_documents", JSON.stringify(uploadedFiles));
    formData.append("upload_file", true);
    formData.append("profile_true", false);

    // if (dataapi.apply_notify_url) {
    //   handleCallYouRecruiteAPI();
    // }

    const response = await apply_job_api(formData);
    if (response.code === 200) {
      enqueueSnackbar("I am running", { variant: "success" });
      enqueueSnackbar(response.message, { variant: "success" });
      setLoading(false);
      setIsSubmitting(false);
      handleNavigateBack();
    } else {
      enqueueSnackbar(response.message, { variant: "error" });
      setLoading(false);
      setIsSubmitting(false);
    }
  };

  const handleCallYouRecruiteAPI = async () => {
    const formData = new FormData();
    formData.append("yourecruit_email", userInfo.email);
    formData.append("yourecruit_first_name", userInfo.first_name);
    formData.append("yourecruit_last_name", userInfo.last_name);
    formData.append("yourecruit_contact_number", userInfo.contact_number);
    formData.append("yourecruit_cover_letter", shortDescription);
    formData.append("yourecruit_cv_file", cv);
    formData.append("yourecruit_address", JSON.stringify(userInfo.address));

    // additional files
    files.forEach((file, index) => {
      formData.append(`yourecruit_additional_files[${index}]`, file);
      formData.append(`yourecruit_additional_files_name[${index}]`, file.name);
    });

    const resp = await yourecruite_api(dataapi.apply_notify_url, formData);
  };

  const handleNavigateBack = () => {
    enqueueSnackbar("I am running", { variant: "success" });

    if (isClientDetailsFlow) {
      handleBack();
      return;
    }
    const path = location.pathname;
    const { source_slug, jobtype_slug } = params;

    // Case 1: /favourite-jobs/detail/:job_slug
    if (path.startsWith("/favourite-jobs/detail/")) {
      navigate("/favourite-job");
      return;
    }
    // Case 2: /:source_slug/job/:job_slug
    if (source_slug && path.includes(`${source_slug}/job/`)) {
      navigate(`/${source_slug}/home`);
      return;
    }

    // Case 3: /:source_slug/:jobtype_slug/job/:job_slug
    if (path.includes("/job/") && source_slug && jobtype_slug) {
      navigate(`/${source_slug}/${jobtype_slug}`);
      return;
    }

    // Default fallback (optional)
    navigate("/home");
  };

  let icon = {
    iconBg: "var(--portal-primary-color)",
  };
  const navigeBack = () => {
    navigate(-1);
  };
  useEffect(() => {
    if (isClientDetailsFlow) return;
    setBreadCrumb([
      {
        name: `${show_proper_words(firstSegment)}`,
        path: `/${firstSegment}`,
        active: false,
      },

      {
        name: `Live Job Feed`,
        path: breadcrumbPath, // ✅ Dynamic path based on source
        active: false,
      },
    ]);
  }, []);
  let login_nfo = localStorage.getItem("user");

  let user_info = login_nfo ? JSON.parse(login_nfo) : null; // Safely parse JSON if data exists
  const handleDownloadAdditiondOC = async (documentPath) => {
    const fileUrl = `${s3baseUri}${documentPath}`;
    const filename = documentPath.split("/").pop();

    try {
      setAdditionalDocDownloadLoading((prev) => ({
        ...prev,
        [documentPath]: true,
      }));
      const response = await fetch(fileUrl, { mode: "cors" });
      const blob = await response.blob();

      const blobUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();

      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
    } finally {
      setAdditionalDocDownloadLoading((prev) => ({
        ...prev,
        [documentPath]: false,
      }));
    }
  };

  const handleDownloadCV = async (cvPath) => {
    if (!cvPath) return;
    const fileUrl = `${s3baseUri}${cvPath}`;
    const filename = cvPath.split("/").pop();
    try {
      setCvDownloadLoading(true);
      const response = await fetch(fileUrl, { mode: "cors" });
      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
    } finally {
      setCvDownloadLoading(false);
    }
  };

  const handleCandidates = (job) => {
    const slug = job.source.slug;

    const jobTypeSlug =
      userInfo.navbar
        ?.find((item) => item.source_slug == slug)
        ?.features.find((feature) => feature.type === "job")?.slug ||
      "live-job-feed";

    navigate(`/${slug}/${jobTypeSlug}/job-candidates-page/${job._id}`, {
      state: {
        job,
        pathname: `/${slug}/live-job-feed/job/${job.job_slug}`, // Pass the source path for breadcrumb
      },
    });
  };

  const handleUpdateSpecificJob = (updatedJob, setData = setDataApi) => {
    if (dataapi._id == updatedJob._id) {
      if (updatedJob.deleted_job_id) {
        enqueueSnackbar("Job deleted successfully", { variant: "success" });
        handleNavigateBack();
        return;
      }
      setData((prev) => ({ ...prev, ...updatedJob }));
    }
  };

  const handleCompanyClick = () => {
    navigate("/user/" + job.created_by._id);
  };

  useEffect(() => {
    // Register the function
    setUpdateJobOnNotification((data) => {
      handleUpdateSpecificJob(data, setDataApi);
    });
    // Cleanup: reset function on unmount
    return () => {
      setUpdateJobOnNotification(() => {});
    };
  }, [dataapi]);

  const is_my_job = userInfo._id === dataapi?.created_by?._id;

  const small_title_label_layout = (icon, title, value) => {
    return (
      <div className="job-info-group">
        <div className="job-info-icon pt-2">
          <img src={icon} alt="" />
        </div>
        <div className="job-info">
          <div className="job-info-title">{title}</div>
          <p className="job-info-value">{value}</p>
        </div>
      </div>
    );
  };

  if (loading) {
    return <PageLoading />;
  }
  return (
    <div className="w-100">
      <div className="container-fluid">
        <div className="card-1 p-4">
          <div className="d-flex justify-content-between gap-2">
            <div className="job-profile-wrapper">
              <div className="job-profile-img">
                <img
                  src={
                    s3baseUri + dataapi?.created_by?.profile_image?.thumbnail_1
                  }
                  alt={dataapi?.created_by?.company_name}
                />
              </div>
              <div className="job-profile-info">
                <div className="job-title">{dataapi.job_title}</div>
                <div
                  onClick={handleCompanyClick}
                  className="company-name hover-primary"
                >
                  {dataapi?.created_by?.company_name}{" "}
                </div>
              </div>
            </div>

            <div className="d-flex gap-2">
              <div>
                {is_my_job && <div className="job-green-chip">My Job</div>}
              </div>
              <div className="job-yellow-chip">{dataapi?.job_type?.title}</div>
              {/* {is_my_job && (
                <img style={{ height: 30 }} src={three_dots_icon} alt="" />
              )} */}
              {userInfo?.role === "candidate" &&
                !userInfo?.isCompanyProfile && (
                  <div>
                    {" "}
                    <IconButton
                      className="p-0"
                      onClick={() => handleBookmarkToggle(dataapi._id)}
                    >
                      {dataapi?.is_favourite ? (
                        <BookmarkIcon
                          sx={{ color: "var(--portal-primary-color)" }}
                        />
                      ) : (
                        <BookmarkBorderIcon />
                      )}
                    </IconButton>
                  </div>
                )}
              {userInfo?.role === "candidate" &&
                !userInfo?.isCompanyProfile &&
                !dataapi?.applied_status && (
                  <div>
                    {" "}
                    <button
                      onClick={(e) => {
                        e.stopPropagation();
                        setOpenQuickApply(true);
                      }}
                      className={`btn-contained-sm tw-group`}
                    >
                      Quick Apply{" "}
                      <ExternalLink className="tw-h-4 tw-w-4 group-hover:tw-translate-x-1 tw-transition-transform" />
                    </button>
                  </div>
                )}
            </div>
          </div>

          <div className="overflow-section mt-4">
            <div className="job-section-heading overflow-heading">Overview</div>
            <div className="row">
              <div className="col-12 col-lg-3">
                <div>
                  {small_title_label_layout(
                    calender_icon,
                    "Date Posted:",
                    new Date(dataapi.createdAt).toLocaleDateString("en-US", {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    })
                  )}
                </div>
                <div className="mt-3">
                  {small_title_label_layout(
                    calender_icon,
                    "Experience:",
                    show_des_data(dataapi?.experience_required?.title)
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-3 border-start hide-border-under-lg ps-lg-4">
                <div>
                  {small_title_label_layout(
                    calender_icon,
                    "Salary:",
                    dataapi?.salary_type === "fixed"
                      ? `€${addCommasToNumber(
                          dataapi?.salary
                        )}/${salaryFrequency(dataapi?.frequency_salary)}`
                      : `€${addCommasToNumber(
                          dataapi?.min_salary
                        )} - €${addCommasToNumber(
                          dataapi?.max_salary
                        )}/${salaryFrequency(dataapi?.frequency_salary)}`
                  )}
                </div>

                <div className="mt-3">
                  {small_title_label_layout(
                    calender_icon,
                    "Education:",
                    formatEducationRequired(dataapi?.education_required?.title)
                  )}
                </div>
              </div>
              <div className="col-12 col-lg-6 border-start hide-border-under-lg ps-lg-4">
                {" "}
                <div>
                  {small_title_label_layout(
                    calender_icon,
                    "source:",
                    dataapi.source.title
                  )}
                </div>
                <div className="mt-3">
                  {small_title_label_layout(
                    calender_icon,
                    "Location:",
                    dataapi?.location
                  )}
                </div>
              </div>
            </div>
          </div>

          <div className="overflow-section mt-4">
            <div className="job-section-heading overflow-heading">
              Job Description
            </div>
            <div className="detail-job-description">
              {/* <JobDescriptionBlock data={dataapi?.description} /> */}
              <div
                dangerouslySetInnerHTML={{ __html: dataapi?.description }}
              ></div>
            </div>
          </div>
          <div className="d-flex justify-content-end">
            {job?.created_by?._id === userInfo?.profile_id &&
              (userInfo?.role == "client" || userInfo?.isCompanyProfile) && (
                <button
                  onClick={(e) => {
                    e.stopPropagation();
                    handleCandidates(job);
                  }}
                  className="theme-button-contained btn-big tw-group position-relative"
                >
                  Candidates
                  <ExternalLink className="ms-2 tw-h-5 tw-w-5 group-hover:tw-translate-x-1 tw-transition-transform" />
                  <div
                    className="badge position-absolute"
                    style={{
                      top: "-7px",
                      right: "-4px",
                      backgroundColor: "#FF0000",
                      color: "#fff",
                      padding: "2px 6px",
                      borderRadius: "12px",
                      minWidth: "20px",
                      textAlign: "center",
                      fontSize: "12px",
                      lineHeight: "1.2",
                    }}
                  >
                    {job?.applicant_count || 0}
                  </div>
                </button>
              )}
          </div>
        </div>
      </div>

      <Box sx={{ mx: "auto", pb: 12 }} className="mt-3 px-4 tw-px-[12px]">
        {/* Upload Section for Other Users */}
        {dataapi.created_by !== user_info?._id &&
          userInfo?.role == "candidate" &&
          !userInfo?.isCompanyProfile && (
            <>
              {/* CV Section with Tooltip */}

              <Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: { xs: "column", sm: "row" },
                    justifyContent: "space-between",
                    alignItems: { xs: "flex-start", sm: "center" },
                    mt: 4,
                    gap: 2,
                  }}
                >
                  <Box>
                    <div className="custom-input-design">
                      <label htmlFor=""> Upload CV *</label>
                    </div>
                    <Typography variant="h6" fontWeight="bold"></Typography>
                    <FormHelperText sx={{ fontSize: "14px", color: "gray" }}>
                      Accepted File types: pdf, docx, doc | Max size: 5 MB
                    </FormHelperText>
                  </Box>

                  {(cvName ||
                    (dataapi?.applied_status && result_application?.cv)) && (
                    <Tooltip
                      title={
                        dataapi?.applied_status &&
                        result_application?.cv &&
                        !cvDownloadLoading
                          ? "Click to download your uploaded CV"
                          : ""
                      }
                      arrow
                      disableHoverListener={
                        !(dataapi?.applied_status && result_application?.cv) ||
                        cvDownloadLoading
                      }
                    >
                      <Box
                        sx={{
                          position: "relative",
                          border: "1px solid silver",
                          borderRadius: "5px",
                          p: 1,
                          mt: { xs: 1, sm: 0 },
                          display: "flex",
                          alignItems: "center",
                          justifyContent: cvDownloadLoading
                            ? "center"
                            : "flex-start",
                          width: dataapi?.applied_status ? "52px" : "200px",
                          minHeight: "52px",
                          marginRight: dataapi?.applied_status
                            ? "300px"
                            : "16px",
                          gap: 1,
                          cursor:
                            dataapi?.applied_status && !cvDownloadLoading
                              ? "pointer"
                              : "default",
                          "&:hover": {
                            backgroundColor:
                              dataapi?.applied_status && !cvDownloadLoading
                                ? "#f5f5f5"
                                : "inherit",
                          },
                        }}
                        onClick={(e) => {
                          if (
                            dataapi?.applied_status &&
                            result_application?.cv &&
                            !cvDownloadLoading
                          ) {
                            e.stopPropagation();
                            handleDownloadCV(result_application.cv);
                          }
                        }}
                      >
                        {cvDownloadLoading ? (
                          <CircularProgress size={20} sx={{ color: "gray" }} />
                        ) : (
                          getFileIcon(
                            cvName || result_application?.cv.split("/").pop(),
                            35
                          )
                        )}
                        {!dataapi?.applied_status && !cvDownloadLoading && (
                          <Typography sx={{ fontSize: "13px" }}>
                            {cvName || result_application?.cv.split("/").pop()}
                          </Typography>
                        )}
                        {!dataapi?.applied_status && (
                          <IconButton
                            size="small"
                            sx={{
                              position: "absolute",
                              top: "-10px",
                              right: "-5px",
                              backgroundColor: "red",
                              color: "white",
                              padding: "1px",
                              "&:hover": {
                                backgroundColor: "red",
                              },
                            }}
                            onClick={(e) => {
                              e.stopPropagation();
                              handleCvNull();
                            }}
                          >
                            <CloseIcon sx={{ fontSize: "15px" }} />
                          </IconButton>
                        )}
                      </Box>
                    </Tooltip>
                  )}

                  {!dataapi?.applied_status ? (
                    <Box>
                      <label htmlFor="image-upload">
                        <input
                          accept=".pdf,.doc,.docx"
                          id="image-upload"
                          type="file"
                          hidden
                          onChange={handleFileChange}
                        />

                        <button
                          className="small-contained-button-field"
                          type="button"
                          onClick={() =>
                            document.getElementById("image-upload").click()
                          }
                          style={{
                            minWidth: "134px",
                          }}
                        >
                          <UploadFile
                            style={{ color: "#fff" }}
                            className="me-2"
                          />
                          Upload CV
                        </button>
                      </label>
                    </Box>
                  ) : (
                    <Box></Box>
                  )}
                </Box>
              </Box>
            </>
          )}
        {userInfo?.role == "candidate" && !userInfo?.isCompanyProfile && (
          <Divider style={{ marginTop: "5px", marginBottom: "5px" }} />
        )}

        {dataapi.created_by !== user_info?._id &&
          userInfo?.role == "candidate" &&
          !userInfo?.isCompanyProfile && (
            <>
              {/* Additional Documents Section with Tooltip */}

              <Box>
                <div className="col-lg-12 col-md-12 col-sm-12 mt-4">
                  <div className="row w-100 div-style ms-0 pt-0">
                    <div className="col-lg-5 col-md-5 col-sm-12 p-0">
                      <div className="custom-input-design">
                        <label htmlFor="">
                          {" "}
                          Additional documents{" "}
                          <span
                            style={{
                              fontSize: "14px",
                              fontWeight: "normal",
                              marginLeft: "5px",
                            }}
                          >
                            (You can upload up to 5 documents)
                          </span>
                        </label>
                      </div>

                      <FormHelperText sx={{ fontSize: "14px", color: "gray" }}>
                        Allowed formats: PDF, DOC, DOCX, XLS, XLSX, JPG, PNG |
                        Max size: 200 MB
                      </FormHelperText>
                    </div>

                    <div className="col-lg-2 col-md-2 col-12">
                      {(files.length > 0 ||
                        (dataapi?.applied_status &&
                          result_application?.additional_documents?.length >
                            0)) && (
                        <>
                          {/* Files uploaded by applicant (show remove icon) */}
                          <></>

                          {!dataapi?.applied_status &&
                            files.length > 0 &&
                            files.map((file, index) => (
                              <Box
                                key={index}
                                sx={{
                                  position: "relative",
                                  border: "1px solid silver",
                                  borderRadius: "5px",
                                  p: 1,
                                  mt: 1,
                                  mb: 1,
                                  display: "inline-flex",
                                  alignItems: "center",
                                  gap: 1,
                                  mr: 1,
                                }}
                              >
                                {getFileIcon(file.name, 35)}
                                <Typography sx={{ fontSize: "13px" }}>
                                  {file.name}
                                </Typography>
                                <IconButton
                                  size="small"
                                  sx={{
                                    position: "absolute",
                                    top: "-10px",
                                    right: "-5px",
                                    backgroundColor: "red",
                                    color: "white",
                                    padding: "1px",
                                  }}
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    removeFile(index);
                                  }}
                                >
                                  <CloseIcon sx={{ fontSize: "15px" }} />
                                </IconButton>
                              </Box>
                            ))}

                          {/* Files uploaded by creator (no remove icon) */}
                          {dataapi?.applied_status &&
                            result_application?.additional_documents?.map(
                              (doc, index) => (
                                <Tooltip
                                  title={
                                    dataapi?.applied_status &&
                                    result_application?.additional_documents
                                      ?.length > 0 &&
                                    !additionalDocDownloadLoading[doc]
                                      ? "Click to download document"
                                      : ""
                                  }
                                  arrow
                                  disableHoverListener={
                                    !(
                                      dataapi?.applied_status &&
                                      result_application?.additional_documents
                                        ?.length > 0
                                    ) || additionalDocDownloadLoading[doc]
                                  }
                                >
                                  <Box
                                    key={`prefilled-${index}`}
                                    sx={{
                                      position: "relative",
                                      border: "1px solid silver",
                                      borderRadius: "5px",
                                      p: 1,
                                      mt: 1,
                                      mb: 1,
                                      display: "inline-flex",
                                      alignItems: "center",
                                      justifyContent:
                                        additionalDocDownloadLoading[doc]
                                          ? "center"
                                          : "flex-start",
                                      gap: 1,
                                      mr: 1,
                                      cursor: additionalDocDownloadLoading[doc]
                                        ? "default"
                                        : "pointer",
                                      "&:hover": {
                                        backgroundColor:
                                          additionalDocDownloadLoading[doc]
                                            ? "inherit"
                                            : "#f5f5f5",
                                      },
                                    }}
                                    onClick={(e) => {
                                      if (!additionalDocDownloadLoading[doc]) {
                                        e.stopPropagation();
                                        handleDownloadAdditiondOC(doc);
                                      }
                                    }}
                                  >
                                    {additionalDocDownloadLoading[doc] ? (
                                      <CircularProgress
                                        size={16}
                                        sx={{ color: "gray" }}
                                      />
                                    ) : (
                                      getFileIcon(doc, 35)
                                    )}
                                    {!dataapi?.applied_status &&
                                      !additionalDocDownloadLoading[doc] && (
                                        <Typography sx={{ fontSize: "13px" }}>
                                          {doc.split("/").pop()}
                                        </Typography>
                                      )}
                                  </Box>
                                </Tooltip>
                              )
                            )}
                        </>
                      )}
                    </div>

                    {!dataapi?.applied_status && (
                      <div className="col-lg-5 col-md-5 col-6 text-start text-md-end pt-2 p-0">
                        <label htmlFor="upload-file">
                          <input
                            type="file"
                            id="upload-file"
                            name="documents"
                            multiple
                            accept=".pdf,.doc,.docx,.xlsx,.xls,.jpg,.jpeg,.png"
                            onChange={handleFileChangeAdditional}
                            style={{ display: "none" }}
                          />

                          <button
                            className="small-contained-button-field"
                            type="button"
                            onClick={() =>
                              document.getElementById("upload-file").click()
                            }
                          >
                            {uploading ? (
                              <CircularProgress
                                size={16}
                                sx={{ color: "white", mr: 1 }}
                              />
                            ) : (
                              <>
                                <FileUploadIcon
                                  style={{ color: "#fff" }}
                                  className="me-2"
                                />
                                Upload
                              </>
                            )}
                          </button>
                        </label>
                      </div>
                    )}
                  </div>
                </div>
              </Box>
            </>
          )}
        {userInfo?.role == "candidate" && !userInfo?.isCompanyProfile && (
          <Divider style={{ marginTop: "5px", marginBottom: "5px" }} />
        )}
        <Box>
          {userInfo?.role == "candidate" && !userInfo?.isCompanyProfile && (
            <>
              <div className="custom-input-design mt-3">
                <label htmlFor="">Cover Letter</label>
                <Tooltip
                  title={
                    dataapi?.applied_status &&
                    result_application?.job_description
                      ? "This is your uploaded Cover Letter / Additional Information. You cannot edit it."
                      : ""
                  }
                  arrow
                >
                  <Box>
                    <textarea
                      style={{ minHeight: 150 }}
                      fullWidth
                      multiline
                      placeholder={
                        dataapi?.applied_status
                          ? ""
                          : "Cover Letter / Additional Information"
                      }
                      value={
                        dataapi?.applied_status
                          ? result_application?.job_description ||
                            shortDescription
                          : shortDescription
                      }
                      disabled={dataapi?.applied_status}
                      onChange={(e) =>
                        !dataapi?.applied_status &&
                        setShortDescription(e.target.value)
                      }
                      sx={{ mt: 1 }}
                    />
                  </Box>
                </Tooltip>
              </div>
            </>
          )}
        </Box>
        {/* Apply Button */}
        <Box display="flex" justifyContent="end" mt={2}>
          {dataapi.created_by !== user_info?._id &&
            !dataapi?.applied_status &&
            userInfo?.role == "candidate" &&
            !userInfo?.isCompanyProfile && (
              <button
                onClick={HandleApplyJob}
                className="theme-button-contained"
                disabled={isSubmitting}
              >
                {isSubmitting ? (
                  <>
                    <CircularProgress
                      size={20}
                      sx={{ color: "white", mr: 1 }}
                    />
                    Applying...
                  </>
                ) : (
                  "Apply now"
                )}
              </button>
            )}
        </Box>
      </Box>

      {openQuickApply && (
        <QuickApplyModal
          open={openQuickApply}
          setOpen={setOpenQuickApply}
          targetJob={dataapi}
          fetchDetails={fetchCategories}
          setJobsList={() => {}}
        />
      )}
    </div>
  );
}
